/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Apikeymanager_Notification_Generated2Inputs */

const id_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API baru berhasil dibuat!`)
};

const ms_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci API baharu berjaya dijana!`)
};

const da_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny API nøgle genereret succesfuldt!`)
};

const de_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neuer API-Schlüssel erfolgreich generiert!`)
};

const en_us2_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New API key generated successfully!`)
};

const es_es2_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Nueva clave de API generada correctamente!`)
};

const es_mx2_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Nueva API key generada exitosamente!`)
};

const fil_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matagumpay na na-generate ang bagong API key!`)
};

const fr_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouvelle clé API générée avec succès !`)
};

const it_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuova chiave API generata con successo!`)
};

const hu_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Új API kulcs sikeresen létrehozva!`)
};

const nl_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nieuwe API-sleutel succesvol gegenereerd!`)
};

const no_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny API-nøkkel generert!`)
};

const pl_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nowy klucz API wygenerowany pomyślnie!`)
};

const pt_br2_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New API key generated successfully!`)
};

const pt_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nova chave de API gerada com sucesso!`)
};

const ro_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noua cheie API a fost generată cu succes!`)
};

const fi_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uusi API-avain luotu onnistuneesti!`)
};

const sv_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ny API-nyckel genererad!`)
};

const vi_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo khóa API mới thành công!`)
};

const tr_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni API anahtarı başarıyla oluşturuldu!`)
};

const cs_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nový API klíč úspěšně vygenerován!`)
};

const bg_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новият API ключ е генериран успешно!`)
};

const ru_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новый API-ключ успешно сгенерирован!`)
};

const uk_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Новий API-ключ успішно згенеровано`)
};

const ar_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم إنشاء مفتاح API جديد بنجاح`)
};

const hi_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API कुंजी उत्पन्न!`)
};

const th_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างคีย์ API ใหม่สำเร็จ`)
};

const ja_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しい API キーを生成しました`)
};

const zh_cn2_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New API key generated successfully!`)
};

const zh_hant1_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New API key generated successfully!`)
};

const ko_components_apikeymanager_notification_generated2 = /** @type {(inputs: Components_Apikeymanager_Notification_Generated2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New API key generated successfully!`)
};

/**
* | output |
* | --- |
* | "New API key generated successfully!" |
*
* @param {Components_Apikeymanager_Notification_Generated2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_apikeymanager_notification_generated2 = /** @type {((inputs?: Components_Apikeymanager_Notification_Generated2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Apikeymanager_Notification_Generated2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_apikeymanager_notification_generated2(inputs)
	if (locale === "ms") return ms_components_apikeymanager_notification_generated2(inputs)
	if (locale === "da") return da_components_apikeymanager_notification_generated2(inputs)
	if (locale === "de") return de_components_apikeymanager_notification_generated2(inputs)
	if (locale === "en-US") return en_us2_components_apikeymanager_notification_generated2(inputs)
	if (locale === "es-ES") return es_es2_components_apikeymanager_notification_generated2(inputs)
	if (locale === "es-MX") return es_mx2_components_apikeymanager_notification_generated2(inputs)
	if (locale === "fil") return fil_components_apikeymanager_notification_generated2(inputs)
	if (locale === "fr") return fr_components_apikeymanager_notification_generated2(inputs)
	if (locale === "it") return it_components_apikeymanager_notification_generated2(inputs)
	if (locale === "hu") return hu_components_apikeymanager_notification_generated2(inputs)
	if (locale === "nl") return nl_components_apikeymanager_notification_generated2(inputs)
	if (locale === "no") return no_components_apikeymanager_notification_generated2(inputs)
	if (locale === "pl") return pl_components_apikeymanager_notification_generated2(inputs)
	if (locale === "pt-BR") return pt_br2_components_apikeymanager_notification_generated2(inputs)
	if (locale === "pt") return pt_components_apikeymanager_notification_generated2(inputs)
	if (locale === "ro") return ro_components_apikeymanager_notification_generated2(inputs)
	if (locale === "fi") return fi_components_apikeymanager_notification_generated2(inputs)
	if (locale === "sv") return sv_components_apikeymanager_notification_generated2(inputs)
	if (locale === "vi") return vi_components_apikeymanager_notification_generated2(inputs)
	if (locale === "tr") return tr_components_apikeymanager_notification_generated2(inputs)
	if (locale === "cs") return cs_components_apikeymanager_notification_generated2(inputs)
	if (locale === "bg") return bg_components_apikeymanager_notification_generated2(inputs)
	if (locale === "ru") return ru_components_apikeymanager_notification_generated2(inputs)
	if (locale === "uk") return uk_components_apikeymanager_notification_generated2(inputs)
	if (locale === "ar") return ar_components_apikeymanager_notification_generated2(inputs)
	if (locale === "hi") return hi_components_apikeymanager_notification_generated2(inputs)
	if (locale === "th") return th_components_apikeymanager_notification_generated2(inputs)
	if (locale === "ja") return ja_components_apikeymanager_notification_generated2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_apikeymanager_notification_generated2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_apikeymanager_notification_generated2(inputs)
	return ko_components_apikeymanager_notification_generated2(inputs)
});
export { components_apikeymanager_notification_generated2 as "components.apiKeyManager.notification.generated" }